/**
 * Default entity ATIs for Atlas/Townsquare (1P).
 */
import type { AtlasEntityATI } from '@atlassian/search-client/common/types';

export type ReadonlyAtlasEntityATI = readonly AtlasEntityATI[];

export const DEFAULT_ATLAS_ENTITY_ATI: ReadonlyAtlasEntityATI = [
	'ati:cloud:townsquare:project',
	'ati:cloud:townsquare:goal',
	'ati:cloud:townsquare:tag',
	'ati:cloud:townsquare:question',
	'ati:cloud:townsquare:learning',
];
